import React, { useState } from 'react'
import { Box, Button, TextField, Typography } from '@mui/material'
import DrawerNav from '../Navigation/DrawerNav'
import { BASE_URL } from '../../Api/constants'
import { useLocation, useNavigate } from 'react-router-dom'

function useQuery() {
    return new URLSearchParams(useLocation().search)
}

export default function ExcelAdd() {
    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const navigate = useNavigate()
    const query = useQuery()
    const examID = query.get('examId')
    const examName = query.get('examName')

    const handleSaveChanges = async () => {
        try {
            const response = await fetch(`${BASE_URL}/api/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    examID,
                })
            })

            const data = await response.json()

            if (response.ok) {
                setName('')
                setDescription('')
                navigate(-1)
            } else {
                console.error(data.message)
            }
        } catch (error) {
            console.error('Error:', error)
        }
    }

    return (
        <Box sx={{ display: 'flex' }}>
            <DrawerNav />
            <Box component='main' sx={{ flexGrow: 1, p: 3 }}>
                <Box p={2}>
                    <Typography variant='h4' sx={{ my: 2, fontWeight: 'bolder', color: '#4b4848' }}>
                        Import Questions using Excel
                    </Typography>
                    <TextField label='Exam' disabled value={examName} fullWidth variant='outlined' margin='normal' />
                    <TextField label='Topic Name' value={name} onChange={(event) => setName(event.target.value)} fullWidth variant='outlined' margin='normal' />
                    <TextField label='Topic Description' value={description} onChange={(event) => setDescription(event.target.value)} fullWidth variant='outlined' margin='normal' />
                    <Box mt={2}>
                        <Button variant='contained' color='success' onClick={handleSaveChanges}>
                            Add Topic
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}
